export default __webpack_public_path__ + "resources/icons/n321-6866.png";